<template>
  <main id="content">
    <b-container class="mt-5 mb-5 high-zindex">
      <b-row>
        <b-col md="6" offset-md="3">
          <h1 class="h2">Feedback</h1>
          <p class="mb-4">The best ideas and suggestions will be featured.</p>
          <b-card class="card-body">
            <b-form @submit="onSubmit">
              <b-form-group label="Name">
                <b-form-input
                  type="text"
                  autocomplete="name"
                  v-model="form.name"
                  v-bind:disabled="!show"
                  placeholder="Enter your full name"
                  autofocus
                />
              </b-form-group>
              <b-form-group label="Email">
                <b-form-input
                  type="email"
                  autocomplete="email"
                  v-model="form.email"
                  v-bind:disabled="!show"
                  placeholder="Enter your work email"
                />
              </b-form-group>
              <b-form-group label="Subject">
                <b-form-input
                  type="text"
                  autocomplete="organization"
                  v-model="form.subject"
                  v-bind:disabled="!show"
                  placeholder="Enter a subject"
                />
              </b-form-group>
              <b-form-group label="Comments">
                <b-form-textarea
                  type="text"
                  v-model="form.message"
                  v-bind:disabled="!show"
                  rows="5"
                  placeholder="Say whatever you want :)"
                />
              </b-form-group>
              <transition name="fade">
                <b-button type="submit" variant="primary"
                  ><span v-if="show">Get in touch</span
                  ><span v-else>Sending...</span
                  ><font-awesome-icon icon="arrow-right" />
                </b-button>
              </transition>
              <transition name="fade">
                <span v-if="sent" class="ml-3 text-success">
                  <span class="mr-2"> <font-awesome-icon icon="check" /> </span
                  >Your message has been sent!
                </span>
              </transition>
              <transition name="fade">
                <span v-if="error" class="ml-3 text-danger">
                  <span class="mr-2">
                    <font-awesome-icon icon="exclamation-triangle" />
                  </span>
                  {{ error }}
                </span>
              </transition>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import constants from "../modules/constants";
export default {
  data: () => {
    return {
      form: {
        email: "",
        name: "",
        subject: "",
        message: ""
      },
      show: true,
      sent: false,
      error: null
    };
  },
  methods: {
    validate() {
      this.error = null;
      if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
          this.form.email
        )
      ) {
        this.error = constants.errors.fill_fields["auth/invalid-email"];
      }
      if (
        !(
          this.form.email &&
          this.form.name &&
          this.form.subject &&
          this.form.message
        )
      ) {
        this.error = constants.errors.fill_fields;
      }
      if (
        this.form.email.trim().length === 0 ||
        this.form.name.trim().length === 0 ||
        this.form.subject.trim().length === 0 ||
        this.form.message.trim().length === 0
      ) {
        this.error = constants.errors.fill_fields;
      }
      setTimeout(() => {
        this.error = null;
      }, 3000);
    },
    onSubmit(event) {
      event.preventDefault();
      this.validate();
      if (!this.show) return;
      if (this.error) return;
      this.show = false;
      const formData = new FormData();
      formData.append("email", this.form.email);
      formData.append("name", this.form.name);
      formData.append("subject", this.form.subject);
      formData.append("message", this.form.message);
      fetch(constants.urls.apiContact, {
        method: "POST",
        mode: "cors",
        body: formData
      })
        .then(response => response.json())
        .then(json => {
          if (json.success !== true) {
            this.error = "An error occurred in sending your form";
          }
          this.form.email = "";
          this.form.name = "";
          this.form.subject = "";
          this.form.message = "";
          this.show = true;
          this.sent = true;
          setTimeout(() => {
            this.sent = false;
          }, 5000);
        })
        .catch(() => {
          this.error = "An error occurred in sending your form";
          this.show = true;
        });
      return false;
    }
  }
};
</script>
